import styled from "styled-components";

export const Container = styled.div`
  &.alert-msg {
    /* min-height: 260px; */
    display: flex;
    align-items: center;
    .modal-body {
      display: flex;
      align-items: center;
      flex-direction: column;
      .modal-title {
        font-size: 30px;
        font-family: "latobold";
        margin-bottom: 7px;
      }
      .ModalContentMsg {
        p {
          font-size: 15px;
          line-height: 25px;
          margin-top: 20px;
          text-align: center;
          padding: 0 12px;
        }
      }
      .AlertBtn {
        background: linear-gradient(180deg, #61b01f 0, #27911b) !important;
        border-radius: 4px;
        width: 80px;
        height: 30px;
        font-size: 13px;
        line-height: 19px;
        color: #ffffff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
      }
    }
    .modal-footer {
      border-top: none;
      padding: 0;
    }
  }
  > Modal {
    > div {
      max-height: calc(80vh - 152px);
      overflow: auto;
      color: $primary-text;
      font-size: 1.125rem;
      text-align: center;
      border: none !important;

      > div {
        padding: 10px !important;
        h3 {
          padding: 24px 24px 0 24px;
          margin: 0;
          color: #0a223a;
          font-weight: bold;
          text-align: center;
          font-size: 28px;
        }
        button {
          background: transparent;
          margin-left: auto;
        }
      }
      p {
        text-align: center !important;
        margin: 0px !important;
      }
    }
  }
  .no-button {
    margin-right: 10px;
    background: #b0b7bb !important;
  }

  @media screen and (min-width: 1024px) {
    Modal {
      margin: auto;
    }
  }
`;

export const AlertButton = styled.div`
  margin-bottom: 60px;
  .AlertBtn {
    width: 115px;
    height: 37px;
  }
`;
